const nameSpace = 'admin/request/budget'

export const actions = {
  SEARCH: `${nameSpace}/SEARCH`,
  UPDATE_SORT_OPTIONS: `${nameSpace}/UPDATE_SORT_OPTIONS`,
  UPDATE_REQUEST_STATUS_FILTER: `${nameSpace}/UPDATE_REQUEST_STATUS_FILTER`,
  UPDATE_KEYWORD_FILTER: `${nameSpace}/UPDATE_KEYWORD_FILTER`,
  UPDATE_PAGE: `${nameSpace}/UPDATE_PAGE`,
  TOGGLE_SELECTED_ITEM: `${nameSpace}/TOGGLE_SELECTED_ITEM`,
  TOGGLE_ALL_SELECTED_ITEMS: `${nameSpace}/TOGGLE_ALL_SELECTED_ITEMS`,
  INIT: `${nameSpace}/INIT`,
  APPROVE_ITEM: `${nameSpace}/APPROVE_ITEM`,
  REJECT_ITEM: `${nameSpace}/REJECT_ITEM`,
  BULK_APPROVE: `${nameSpace}/BULK_APPROVE`,
}

export const getters = {
  searchResult: `${nameSpace}/searchResult`,
  loading: `${nameSpace}/loading`,
  sortOptions: `${nameSpace}/sortOptions`,
  filter: `${nameSpace}/filter`,
  selectedItems: `${nameSpace}/selectedItems`,
  approvableItems: `${nameSpace}/approvableItems`,
  selectedApprovableItems: `${nameSpace}/selectedApprovableItems`,
}
